import styled from "styled-components";
import Lottie from "react-lottie";

import scannerAnim from "../../animations/11564-scanner-animation.json";

interface LottieLoaderHolderProps {
    show: boolean
}

export const LottieLoaderHolder = styled.div.attrs(({ show }: LottieLoaderHolderProps) => ({
    className: show ? 'show' : '',
}))<LottieLoaderHolderProps>`
  z-index: 400;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  opacity: 0;
  transform: rotate(-5deg) scale(1.1);
  pointer-events: none;
  &.show {
    opacity: 1;
    transform: unset;
    pointer-events: all;
  }

  transition: 1000ms ease;
  backdrop-filter: blur(4px);

  display: flex;
  justify-content: center;
  align-items: center;
`

export const LottieLoaderComponent = styled(Lottie).attrs({
    width: 250,
    height: 250,
    options: {
        animationData: scannerAnim,
        loop: true,
        autoplay: true,
    },
})`

`